import {Trans} from 'react-i18next'

import {Box, useTheme} from '@mui/material'
import {
  getProductLineColors,
  PGTypography,
  useProductLine,
} from '@progynyglobal/pg-ui-library'

type JumboTitleProps = {
  title?: string | null
  description?: string | null
  children: React.ReactNode
  disableContentWrapper?: boolean
  forceDefaultHeight?: boolean
}

const JumboTitle = ({
  title,
  description,
  children,
  disableContentWrapper = false,
  forceDefaultHeight = false,
}: JumboTitleProps) => {
  const theme = useTheme()

  const {productLine} = useProductLine()
  const colors = getProductLineColors(productLine)

  const isSmall = !title && !description
  const isBackgroundSmall = isSmall && !forceDefaultHeight

  return (
    <Box pb={{md: 10}}>
      <Box
        sx={{
          '&::before': {
            content: "''",
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: disableContentWrapper
              ? {
                  xs: isBackgroundSmall ? 140 : 300,
                  md: isBackgroundSmall ? 200 : 456,
                }
              : isBackgroundSmall
                ? 200
                : 456,
            backgroundColor: colors.primary,
            zIndex: -1,
          },
        }}
      />
      <Box
        width={'100%'}
        display={'flex'}
        flexDirection={'column'}
        alignItems={
          disableContentWrapper ? {xs: 'flex-start', md: 'center'} : 'center'
        }
        justifyContent={
          disableContentWrapper ? {xs: 'flex-start', md: 'center'} : 'center'
        }
        height={
          disableContentWrapper
            ? {xs: isSmall ? 140 : 300, md: isSmall ? 200 : 456}
            : isSmall
              ? 200
              : 456
        }
        pt={disableContentWrapper ? {xs: 4, md: 0} : 0}
        px={disableContentWrapper ? {xs: 1, md: 0} : 0}
        gap={{xs: 1, md: 0}}
      >
        {title && (
          <PGTypography
            variant='header'
            as='h2'
            color={theme.palette.common.white}
            textAlign={'center'}
            style={{fontSize: 32, fontWeight: 700, lineHeight: 1.4}}
          >
            {title}
          </PGTypography>
        )}
        {description && (
          <PGTypography
            sx={{
              width: {xs: '100%', md: '40%'},
              textAlign: disableContentWrapper
                ? {xs: 'left', md: 'center'}
                : 'center',
            }}
            variant='subtitle'
            color={theme.palette.other.brandColors.white}
          >
            <Trans>{description}</Trans>
          </PGTypography>
        )}
      </Box>
      {disableContentWrapper ? (
        <Box ml={{md: 10}} mr={{md: 10}} mt={{xs: -6, md: -8}}>
          {children}
        </Box>
      ) : (
        <Box
          mt={-8}
          ml={10}
          mr={10}
          padding={{xs: 2, md: 4}}
          borderRadius='16px'
          border={`1px solid #E8EAF0`}
          sx={{
            boxShadow: '0 14px 36px 0 #07378F1A',
            backgroundColor: theme.palette.common.white,
          }}
        >
          {children}
        </Box>
      )}
    </Box>
  )
}

export default JumboTitle
